import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';

const CustomMap = ({ geoUrl, mapData, selectedRegion, setSelectedRegion, disableSelection = false, singleToneColor = false }) => {

    const getColorScale = (hasState) => {
        if (hasState) return "#16a34a"; // default gray for no data
        return "#6ddc81"; // darkest green for 75-100%
    };

    return (
        <React.Fragment>
            {/* Map */}
            {selectedRegion && <div className='text-gray-500 z-50 pointer-events-none flex flex-col gap-1 justify-start items-end text-lg w-full'>
                <label className={`font-semibold text-white rounded-md px-2`}
                    style={{
                        backgroundColor: singleToneColor ? '#16a34a' : '#115d31'
                    }}
                >{selectedRegion === 'all_state' ? 'All States' : selectedRegion || 'N/A'}</label>
            </div>}

            <ComposableMap projection="geoAlbersUsa">
                <Geographies geography={geoUrl}>
                    {({ geographies }) =>
                        geographies.map(geo => {
                            const stateName = geo.properties.name;
                            const percentage = mapData[stateName];
                            const hasState = mapData.findIndex(state => state === stateName) !== -1;
                            const isSelected = stateName === selectedRegion;
                            const centroid = geo.properties.centroid || [0, 0];
                            const singleToneColorFill = (rest) => singleToneColor ? isSelected ? "#16a34a" : "#6ddc81" : rest;
                            return (
                                <g key={geo.rsmKey}>
                                    <Geography
                                        geography={geo}
                                        onClick={() => {
                                            if (!disableSelection && hasState) {
                                                setSelectedRegion(stateName);
                                            }
                                        }}
                                        style={{
                                            default: {
                                                fill: singleToneColorFill(isSelected ? "#115d31" : getColorScale(hasState)),
                                                outline: "none"
                                            },
                                            hover: {
                                                fill: singleToneColorFill(hasState ? "#115d31" : "#6ddc81"),
                                                outline: "none",
                                                cursor: !disableSelection && hasState ? 'pointer' : 'default'
                                            },
                                            pressed: {
                                                fill: singleToneColorFill(hasState ? "#115d31" : "#6ddc81"),
                                                outline: "none"
                                            }
                                        }}
                                    />
                                    <text
                                        x={centroid[0]}
                                        y={centroid[1]}
                                        textAnchor="middle"
                                        fill="#374151"
                                        fontSize={10}
                                    >
                                        {`${percentage || 0}%`}
                                    </text>
                                </g>
                            );
                        })
                    }
                </Geographies>
            </ComposableMap>
        </React.Fragment>
    );
};

export default CustomMap; 